'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.year;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/year.js
// module id = 756
// module chunks = 0